import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Swal from 'sweetalert2';
import $ from 'jquery';
import { toast } from 'react-toastify';
import voca from 'voca';
import axios from 'axios';
import cookie from 'react-cookies';
import { dynamicSort } from '../../common/utils/api_utils';
import './plugins/form/index';
import './plugins/dataTable/index';
import './plugins/dataGroup/index';
import './plugins/browserStorageSetter/index';
import './plugins/collectionForm/index';
import './plugins/loginPlugin/loginForm/index';
import './plugins/loginPlugin/userSignUpForm/index';
import './plugins/loginPlugin/changePassword/index';
import './plugins/collectionTraits/index';
import './plugins/collectionImageTraits/index';
import './plugins/iframeTraits/index';
import './plugins/collectionVideoTraits/index';
import './plugins/eventTraits/index';
import './plugins/snippet/index';
import './plugins/subPage/index';
import './plugins/customComponent/index';
import './plugins/customSegment/index';
import './plugins/hrefTraits/index';
import './plugins/subscriberForm/index';
import './plugins/pagination/index';
import './plugins/dateRangeComponent/index';
import './plugins/stripe-payment/index';
import './plugins/icons/index';
import './plugins/progressBar/index';
import './plugins/plaid/index';
import './plugins/searchForm/index';
import './plugins/dataMap/index';
import './plugins/dataGroupMap/index';
import './plugins/innerDataGroup/index';
import './plugins/innerDataList/index';
import './plugins/pageSearchForm/index';
import './plugins/preBuiltSection/index';
import './plugins/themePage/index';
import './plugins/market-place-cart';
import './plugins/carouselTraits/index';
import './plugins/cardsTraits/index';
import './plugins/addRemoveCollectionForm/index';
import './plugins/chat/atomchat/index';
import './plugins/chart/index';
import './plugins/preBuiltClassesTraits/index';
import './plugins/collectionAudioTraits/index';
import './plugins/snipcart-ecommerce/index';
import './plugins/stripe-connect/index';
import './plugins/dataGroupExternalAPI/index';
//import './plugins/autocomplete/index';
import './plugins/autocompleteInput/index';
import './plugins/exportButton/index';
import './plugins/questionnaire-survey-form/index';
import './plugins/questionnaire-survey-form-field/index';
import './plugins/questionnaire-survey-form-submission/index';
import './plugins/paginationNumber/index';
import './plugins/bng-payment/index';
import './plugins/fluid-pay/index';
import './plugins/dataTableDynamic/index';
import './plugins/userTenantDropdown/index';
import './plugins/calendar/index';
import './plugins/calendarTimeslot/index';
import './plugins/permission/index';
import './plugins/chatbotMessage/index';
import './plugins/roleMappingDropdown/index';
import './plugins/messaging/index';
import './plugins/totp';
import './plugins/imagine-pay';
import './plugins/actionSubmit';
import './plugins/pageList';
import './plugins/pdfViewer/index';
import './plugins/stripe-payment-methods/index';
import './plugins/stripe-payment-methods-list/index';
import './plugins/otpAuthenticator/index';
import './plugins/otpGenerationForm/index';
import './plugins/aiComponents/index';
import './plugins/typesenseSearch/index';
import './plugins/subTenantDropdown/index';
import './plugins/paginationPageSize/index';
import './plugins/socketAlert/index';
import { cleanBlockCategories, configureEditor } from '../../common/utils/geditor_utils';
import { getPageCollectionFields, getSnippetCollectionFields } from './apiUtils';
import CustomLoader from '../common/CustomLoader';
import { getCustomFormThemesStyle, loadCustomCSSClasses } from './plugins/pluginComponentApi';
import geditorBuilder, { resetGeditor } from './geditorBuilder';
import { filterByKey } from '../../common/utils/api_utils';
import { showWarning } from '../../common/utils/alert';
import { loadOrganizationDetails, updateUserIpInCookie } from '../home/app_util';
import { builderSurfaceJsonContentHeader } from '../../common/utils/restApiHeaderUtils';
import { restartApplication } from '../../common/utils/restart-utils';
import PublishProjectModal from './PublishProjectModal';
import PreviewProjectModal from './PreviewProjectModal';
class GEditor extends Component {
  static propTypes = {
    projectId: PropTypes.string.isRequired,
    uri: PropTypes.string.isRequired,
    project: PropTypes.object.isRequired,
    editor: PropTypes.object.isRequired,
  };

  state = {
    editor: null,
    editorDoc: null,
    editorWindow: null,
    displayBlock: false,
    bindCollectionOptions: null,
    menu: [{ label: 'Create Page' }, { label: 'Context menu is fun' }, { label: 'Cool' }],
    popoverOpen: false,
    isPublising: false,
    previewModalOpen: false,
    previewUrl: '',
    selVersion: {
      ALPHA: this.props.version,
      BETA: this.props.version,
      PREVIEW: this.props.version,
      PRODUCTION: this.props.version,
    },
  };

  toggle = () => {
    this.setState({ popoverOpen: !this.state.popoverOpen });
  };

  handleVersionChange = (event, type) => {
    const { selVersion } = this.state;
    const {
      target: { value },
    } = event;
    selVersion[type] = value;
    this.setState({ selVersion });
  };

  togglePreview = (previewUrl) => {
    this.setState({ previewModalOpen: !this.state.previewModalOpen, previewUrl });
  };

  toggleBlock = () => {
    this.setState({ displayBlock: !this.state.displayBlock });
  };

  // componentWillUnmount() {
  //   // resetGeditor();
  // }

  createEditor = (
    uri,
    collections,
    events,
    externalApis,
    bindCollectionOptions,
    installedPlugins,
    slug,
    snippetCollectionTraitOptions,
  ) => {
    const { assets } = this.props;
    $('#blocks').html('');
    $('#layer-manager').html('');
    let { editor } = this.state;
    const { project, projectId, token, version, versions } = this.props;
    resetGeditor();
    const geditorBuilderOption = {
      uri,
      projectId,
      version,
      token,
      collections,
      events,
      externalApis,
      assets,
      bindCollectionOptions,
      installedPlugins,
      snippetCollectionTraitOptions,
      project,
    };
    editor = geditorBuilder(geditorBuilderOption);
    editor.Panels.removeButton('views', 'open-layers');
    setTimeout(
      () =>
        configureEditor(
          editor,
          project,
          version,
          versions,
          this.toggle,
          slug,
          this.togglePreview,
          geditorBuilderOption,
        ),
      1000,
    );
    return editor;
  };

  async componentDidMount() {
    const { pageId, projectId, uri, editor, version } = this.props;
    const { pages } = editor;
    const currentPage = filterByKey(pages, 'uuid', pageId);
    await this.loadTraitOptions(pageId, projectId, version, uri, editor, currentPage);
  }

  loadTraitOptions = async (pageId, projectId, version, uri, editor, currentPage) => {
    const { plugins, collections, externalApis, events } = editor;
    // Removed constructors from the Collection object to prevent JSON parse issue in Builder Editor
    if (collections && collections.length) {
      collections.forEach((coll) => {
        delete coll['_id'];
        delete coll['__v'];
        delete coll['constructors'];
      });
    }
    console.log('*** noConstructor Collections:', collections);
    const loginSignUp = plugins.find((e) => e.code === 'LOGIN');
    const multiTenantPlugin = plugins.find((e) => e.code === 'MULTI_TENANT_SAAS');
    const collectionTraitOptions = await getPageCollectionFields(
      pageId,
      projectId,
      version,
      loginSignUp,
      collections,
      multiTenantPlugin,
    );
    const snippetCollectionTraitOptions = await getSnippetCollectionFields(
      pageId,
      projectId,
      version,
      collections,
    );
    if (!currentPage && collectionTraitOptions && collectionTraitOptions.page) {
      currentPage = collectionTraitOptions.page;
    }
    const slug = currentPage ? currentPage.slug : '';
    const drapcodeEditor = this.createEditor(
      uri,
      collections,
      events,
      externalApis,
      collectionTraitOptions,
      plugins,
      slug,
      snippetCollectionTraitOptions,
    );

    setTimeout(() => {
      const canvas = drapcodeEditor.Canvas;
      const editorDoc = canvas.getDocument();
      const editorWindow = canvas.getWindow();
      cleanBlockCategories();
      this.setProjectCustomCSSCdn(drapcodeEditor);
      this.loadProjectCustomCss(drapcodeEditor);
      this.loadCustomFormThemes(drapcodeEditor);
      this.loadCustomCSSClasses(drapcodeEditor, projectId, version);
      this.setPageDirection(drapcodeEditor, currentPage);
      this.setProjectCustomJSCdn(drapcodeEditor);
      this.setProjectCustomScript(drapcodeEditor);
      this.setPageExternalScriptUrl(drapcodeEditor, currentPage);
      this.loadProjectCustomThemeCSS(drapcodeEditor);
      //TODO: Ali -> Review and remove adding of Page Custom Script on Builder Canvas.
      // this.setPageCustomScript(drapcodeEditor, currentPage);

      this.setState({
        editor: drapcodeEditor,
        editorDoc,
        editorWindow,
      });

      console.log('🚀 ~ file: GEditor ~ Loaded Builder Canvas...');
      //?INFO: -> Commented code below to disable Builder Loader Screen
      // let { showBuilderCanvasLoader } = this.props;
      // console.log('🚀 ~ file: GEditor ~ BuilderCanvasLoader:', showBuilderCanvasLoader);
      // if (showBuilderCanvasLoader) this.props.actions.hideBuilderLoader();
      const switchVersionBtn = document.getElementById('switch-version');
      if (switchVersionBtn) {
        switchVersionBtn.innerHTML = ` (v${version})`;
      }
    }, 1000);
  };

  appendStyle = (editor, customCSS, appendInBody = false) => {
    let rootStyle = document.createElement('style');
    rootStyle.appendChild(document.createTextNode(customCSS));
    const canvas = editor.Canvas;
    const iframe = canvas.getFrameEl();
    if (iframe && iframe.contentDocument) {
      if (appendInBody) {
        iframe.contentDocument.body.appendChild(rootStyle);
      } else {
        iframe.contentDocument.head.appendChild(rootStyle);
      }
    }
  };

  loadProjectCustomCss = async (editor) => {
    const project = this.props.project;
    const { content } = project ? project : {};
    const { customCSS } = content ? content : {};
    let contentCustomCSS = customCSS ? customCSS : '';
    this.appendStyle(editor, contentCustomCSS);
  };

  generateCustomThemeCSS = (theme) => {
    const generateButtonSpacingStyles = () => {
      let buttonStyles = '';

      if (theme.Margin) {
        buttonStyles += `.btn { margin: ${theme.Margin}; }`;
      } else if (theme.MarginTop || theme.MarginRight || theme.MarginBottom || theme.MarginLeft) {
        buttonStyles += `.btn { 
          margin: ${theme.MarginTop || '0'} ${theme.MarginRight || '0'} ${
          theme.MarginBottom || '0'
        } ${theme.MarginLeft || '0'}; 
        }`;
      }

      if (theme.Padding) {
        buttonStyles += `.btn { padding: ${theme.Padding}; }`;
      } else if (
        theme.PaddingTop ||
        theme.PaddingRight ||
        theme.PaddingBottom ||
        theme.PaddingLeft
      ) {
        buttonStyles += `.btn { 
          padding: ${theme.PaddingTop || '0'} ${theme.PaddingRight || '0'} ${
          theme.PaddingBottom || '0'
        } ${theme.PaddingLeft || '0'}; 
        }`;
      }

      if (theme.Border) {
        buttonStyles += `.btn { border: ${theme.Border} solid currentColor; }`;
      } else if (theme.BorderTop || theme.BorderRight || theme.BorderBottom || theme.BorderLeft) {
        buttonStyles += `.btn { 
          border-width: ${theme.BorderTop || '0'} ${theme.BorderRight || '0'} ${
          theme.BorderBottom || '0'
        } ${theme.BorderLeft || '0'}; 
          border-style: solid; 
          border-color: currentColor; 
        }`;
      }

      if (theme.BorderRadius) {
        buttonStyles += `.btn { border-radius: ${theme.BorderRadius}; }`;
      } else {
        const borderRadius = [
          theme.BorderRadiusTop || '0',
          theme.BorderRadiusRight || '0',
          theme.BorderRadiusBottom || '0',
          theme.BorderRadiusLeft || '0',
        ].join(' ');

        if (borderRadius.trim() !== '0 0 0 0') {
          buttonStyles += `.btn { border-radius: ${borderRadius}; }`;
        }
      }

      return buttonStyles;
    };

    return `
  body {
    ${theme.body && theme.body.color ? `color: ${theme.body.color};` : ''}
    ${
      theme.body && theme.body.backgroundColor
        ? `background-color: ${theme.body.backgroundColor};`
        : ''
    }
    ${theme.bodyFont && theme.bodyFont.value ? `font-family: ${theme.bodyFont.value};` : ''}
  }
  a {
    ${theme.body && theme.body.anchor ? `color: ${theme.body.anchor};` : ''}
  }
  a:hover {
    ${theme.body && theme.body.anchorHover ? `color: ${theme.body.anchorHover};` : ''}
  }

  ${['h1', 'h2', 'h3', 'h4', 'h5', 'h6']
    .map(
      (tag) => `
      ${
        theme[tag + 'Font'] && theme[tag + 'Font'].value
          ? `${tag} { font-family: ${theme[tag + 'Font'].value}; }`
          : ''
      }
      ${theme[tag + 'FontSize'] ? `${tag} { font-size: ${theme[tag + 'FontSize']}; }` : ''}
      ${theme[tag + 'Color'] ? `${tag} { color: ${theme[tag + 'Color']}; }` : ''}
    `,
    )
    .join('')}

  ${['primary', 'danger', 'success', 'warning', 'info', 'light', 'dark', 'link']
    .map(
      (color) => `
      ${
        theme.colors && theme.colors[color]
          ? `.btn-${color} { background-color: ${theme.colors[color]}; }`
          : ''
      }
      ${
        theme.hoverColors && theme.hoverColors[color]
          ? `.btn-${color}:hover { background-color: ${theme.hoverColors[color]}; }`
          : ''
      }
    `,
    )
    .join('')}

  ${generateButtonSpacingStyles()}
`
      .replace(/\s+/g, ' ')
      .trim();
  };

  loadProjectCustomThemeCSS = async (editor) => {
    const project = this.props.project;
    const { customThemeProps } = project ? project : {};
    if (customThemeProps && Object.keys(customThemeProps).length > 0) {
      const customThemeCSS = this.generateCustomThemeCSS(customThemeProps);
      this.appendStyle(editor, customThemeCSS, true);
    }
  };

  loadCustomFormThemes = async (editor) => {
    const formThemesStyle = await getCustomFormThemesStyle();
    this.appendStyle(editor, formThemesStyle);
  };

  loadCustomCSSClasses = async (editor, projectId, version) => {
    const cssClasses = await loadCustomCSSClasses(projectId, version);
    this.appendStyle(editor, cssClasses);
  };

  setPageDirection = async (editor, currentPage) => {
    const canvas = editor.Canvas;
    let iframe = canvas.getFrameEl();
    const pageDirection = currentPage && currentPage.pageDirection ? currentPage.pageDirection : '';
    if (iframe && iframe.contentDocument && pageDirection) {
      iframe.contentDocument.body.setAttribute('dir', pageDirection);
    }
  };

  setPageExternalScriptUrl = async (editor, currentPage) => {
    const canvas = editor.Canvas;
    let iframe = canvas.getFrameEl();
    const { externalScriptURL } = currentPage ? currentPage : '';
    const externalScriptURLs = currentPage && externalScriptURL ? externalScriptURL.split(',') : '';
    externalScriptURLs &&
      externalScriptURLs.forEach((externalScriptURL) => {
        if (iframe && iframe.contentDocument && externalScriptURL) {
          const script = document.createElement('script');
          script.src = externalScriptURL.trim();
          script.async = true;
          script.defer = true;
          iframe.contentDocument.body.appendChild(script);
        }
      });
  };

  setPageCustomScript = async (editor, currentPage) => {
    const canvas = editor.Canvas;
    let iframe = canvas.getFrameEl();
    const { customScript, loadCustomScriptToBuilder } = currentPage ? currentPage : '';
    const loadCustomScript =
      typeof loadCustomScriptToBuilder === 'undefined' ? true : loadCustomScriptToBuilder;
    const customScriptContent =
      currentPage && loadCustomScript && customScript ? customScript.trim() : '';
    if (iframe && iframe.contentDocument && customScriptContent) {
      let clearScriptTags = customScriptContent.startsWith('<script>')
        ? customScriptContent.replace('<script>', '')
        : customScriptContent;
      clearScriptTags = clearScriptTags.endsWith('</script>')
        ? clearScriptTags.replace('</script>', '')
        : clearScriptTags;

      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.appendChild(document.createTextNode(clearScriptTags));
      iframe.contentDocument.body.appendChild(script);
    }
  };

  setProjectCustomCSSCdn = async (editor) => {
    const project = this.props.project;
    try {
      const { customCssCdns, loadAllCssCdnToBuilder } = project ? project : '';
      let projectCustomCssCdnsArr = [];

      if (project && customCssCdns && loadAllCssCdnToBuilder) {
        customCssCdns.map((customCssCdn) => {
          if (customCssCdn.loadToBuilder) {
            if (customCssCdn.sortOrder || customCssCdn.sortOrder === 0) {
              projectCustomCssCdnsArr.push(customCssCdn);
            } else {
              customCssCdn['sortOrder'] = 0;
              projectCustomCssCdnsArr.push(customCssCdn);
            }
          }
        });
      }
      let iframe = editor.Canvas.getFrameEl();
      projectCustomCssCdnsArr.sort(dynamicSort('sortOrder')).map((customCssCdn) => {
        if (customCssCdn.loadToBuilder && customCssCdn.urlOrTag.startsWith('<link')) {
          if (iframe && iframe.contentDocument && customCssCdn) {
            const iframeClass = iframe.className;
            const cssCdnString = customCssCdn.urlOrTag.trim();
            if (iframeClass && cssCdnString) {
              $(`.${iframeClass}`).contents().find('head').append(cssCdnString);
            }
          }
        } else if (
          customCssCdn.loadToBuilder &&
          (customCssCdn.urlOrTag.startsWith('http') || customCssCdn.urlOrTag.startsWith('ftp'))
        ) {
          if (iframe && iframe.contentDocument && customCssCdn) {
            const linkElem = document.createElement('link');
            linkElem.href = customCssCdn.urlOrTag.trim();
            linkElem.rel = 'stylesheet';
            linkElem.crossorigin = true;
            iframe.contentDocument.head.appendChild(linkElem);
          }
        }
      });
    } catch (error) {
      console.error(error);
    }
  };

  setProjectCustomJSCdn = async (editor) => {
    const project = this.props.project;
    const canvas = editor.Canvas;
    let iframe = canvas.getFrameEl();
    try {
      const { customJsCdns, loadAllJsCdnToBuilder } = project ? project : '';
      let projectCustomJsCdnsArr = [];
      if (project && customJsCdns && loadAllJsCdnToBuilder) {
        customJsCdns.map((customJsCdn) => {
          if (customJsCdn.loadToBuilder) {
            if (customJsCdn.sortOrder || customJsCdn.sortOrder === 0) {
              projectCustomJsCdnsArr.push(customJsCdn);
            } else {
              customJsCdn['sortOrder'] = 0;
              projectCustomJsCdnsArr.push(customJsCdn);
            }
          }
        });
      }

      projectCustomJsCdnsArr.sort(dynamicSort('sortOrder')).map((customJsCdn) => {
        if (customJsCdn.loadToBuilder && customJsCdn.urlOrTag.startsWith('<script')) {
          const scriptTagOpen = '<script';
          const scriptTagClose = '></script>';
          let scriptCdnTagContent = customJsCdn.urlOrTag
            .trim()
            .replace(scriptTagOpen, '')
            .replace(scriptTagClose, '');
          if (iframe && iframe.contentDocument && customJsCdn) {
            const iframeClass = iframe.className;
            const scriptString = '<scr' + 'ipt' + scriptCdnTagContent + '></scr' + 'ipt>';
            if (iframeClass && scriptString) {
              $(`.${iframeClass}`).contents().find('body').append(scriptString);
            }
          }
        } else if (
          customJsCdn.loadToBuilder &&
          (customJsCdn.urlOrTag.startsWith('http') || customJsCdn.urlOrTag.startsWith('ftp'))
        ) {
          if (iframe && iframe.contentDocument && customJsCdn) {
            const scriptElem = document.createElement('script');
            scriptElem.src = customJsCdn.urlOrTag.trim();
            scriptElem.async = true;
            scriptElem.defer = true;
            iframe.contentDocument.body.appendChild(scriptElem);
          }
        }
      });
    } catch (error) {
      console.error(error);
    }
  };

  setProjectCustomScript = async (editor) => {
    const project = this.props.project;
    const canvas = editor.Canvas;
    let iframe = canvas.getFrameEl();
    try {
      const { content, loadCustomJsToBuilder } = project ? project : '';
      const { customJS } = content ? content : '';
      const customScriptContent =
        project && loadCustomJsToBuilder && content && customJS ? customJS.trim() : '';
      if (iframe && iframe.contentDocument && customScriptContent) {
        let clearScriptTags = customScriptContent.startsWith('<script>')
          ? customScriptContent.replace('<script>', '')
          : customScriptContent;
        clearScriptTags = clearScriptTags.endsWith('</script>')
          ? clearScriptTags.replace('</script>', '')
          : clearScriptTags;
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.appendChild(document.createTextNode(clearScriptTags));
        iframe.contentDocument.body.appendChild(script);
      }
    } catch (error) {
      console.error(error);
    }
  };

  shouldComponentUpdate(nextProps, nextState, nextContext) {
    if (nextProps.uri !== this.props.uri) {
      const { editor, projectId, plugins, version } = this.props;
      const { pageId, uri } = nextProps;
      const { pages } = editor;
      const currentPage = filterByKey(pages, 'uuid', pageId);
      this.loadTraitOptions(pageId, projectId, version, uri, editor, currentPage);
    }
    return true;
  }
  componentDidUpdate(prevProps) {
    const isNextEvents =
      prevProps.editor.events &&
      this.props.editor.events &&
      prevProps.editor.events.length !== this.props.editor.events.length;
    if (isNextEvents) {
      const { editor, projectId, version, pageId, uri } = this.props;
      const { pages } = editor;
      const currentPage = filterByKey(pages, 'uuid', pageId);
      this.loadTraitOptions(pageId, projectId, version, uri, editor, currentPage);
    }
  }

  generateProjectURL = (envType, domainName, seoName, slug = '', link = false) => {
    let url = '';
    console.log('envType PREVIEW', envType);
    const exchangeSurfaceUrl = process.env.REACT_APP_EXCHANGE_SURFACE;
    if (envType === 'ALPHA') {
      url = `${seoName}.uat.${exchangeSurfaceUrl}`;
    } else if (envType === 'BETA') {
      url = `${seoName}.sandbox.${exchangeSurfaceUrl}`;
    } else if (envType === 'PRODUCTION') {
      // if (domainName) {
      //   url = domainName;
      // } else {
      url = `${seoName}.${exchangeSurfaceUrl}`;
      // }
    } else if (envType === 'PREVIEW') {
      url = `${seoName}.preview.${exchangeSurfaceUrl}`;
    }
    if (slug) {
      url += `${slug}`;
    }
    let protocol = `https`;
    let environment = process.env.REACT_APP_ENVIRONMENT || '';
    if (environment) {
      environment = environment.toLowerCase().trim();
    }
    //Overriding Exchange Surface URL protocol for DEV environment
    if (environment.startsWith('dev')) {
      protocol = `http`;
    }

    if (link) {
      return `${protocol}://${url}`;
    }
    return (
      <>
        <i className="wb webconnect-box-arrow-in-up-right" title="Open link in new tab"></i>
        <a
          className="icon-link"
          href={`${protocol}://${url}`}
          target="_blank"
          title="Open link in new tab"
        >
          {`${protocol}://${url}`}
        </a>
      </>
    );
  };

  restartApp = async () => {
    const { project } = this.props;
    await restartApplication(project.seoName);
  };

  publishApp = async (envType, name) => {
    const { project, actions } = this.props;
    if (!project) {
      return '';
    }
    console.log('envType', envType);
    let selVersion = this.state.selVersion[envType];
    if (!selVersion) {
      selVersion = 1;
    }
    console.log('this.state.selVersion', selVersion);
    const preconfirm = async () => {
      this.setState({ isPublising: true });
      let exchangeEngineUrl = process.env.REACT_APP_EXCHANGE_ENGINE;
      if (envType === 'ALPHA') {
        exchangeEngineUrl = process.env.REACT_APP_EXCHANGE_ENGINE_ALPHA;
      } else if (envType === 'BETA') {
        exchangeEngineUrl = process.env.REACT_APP_EXCHANGE_ENGINE_BETA;
      } else if (envType === 'PRODUCTION') {
        exchangeEngineUrl = process.env.REACT_APP_EXCHANGE_ENGINE;
      } else if (envType === 'PREVIEW') {
        exchangeEngineUrl = process.env.REACT_APP_EXCHANGE_ENGINE_PREVIEW;
      }

      let protocol = `https`;
      let environment = process.env.REACT_APP_ENVIRONMENT || '';
      if (environment) {
        environment = environment.toLowerCase().trim();
      }
      //Overriding publish Exchange Engine API URL protocol for DEV environment
      if (environment.startsWith('dev')) {
        protocol = `http`;
      }

      const { seoName, uuid } = project;
      console.log('Publishing *****', actions);
      try {
        toast.info('Started Publishing the Application.');
        await actions.updateLatestPublishVersion({
          projectId: uuid,
          latestVersion: selVersion,
          envType,
        });

        const exchangeEngineApiUrl = `${protocol}://${seoName}.${exchangeEngineUrl}api/v1/projects/build/${uuid}/version/${selVersion}`;
        const res = await axios.post(
          exchangeEngineApiUrl,
          { subscription: loadOrganizationDetails('subscription') },
          {
            headers: {
              'Content-Type': 'application/json',
              projectId: uuid,
            },
          },
        );
        this.setState({ isPublising: false });
        if (res.data.message === 'Build Success') {
          try {
            const userIp = cookie.load('userIp') || (await updateUserIpInCookie());
            const header = builderSurfaceJsonContentHeader(uuid, true, userIp, envType);
            await axios.post(
              `${process.env.REACT_APP_BUILDER_ENGINE}publish/savedata`,
              {
                projectId: uuid,
                version: selVersion,
              },
              header,
            );
          } catch (error) {
            console.log('error in tracking publish', error);
          }
          toast.success('Application Published Successfully!');
          return { success: true, data: res.data };
        } else {
          toast.error(`Failed to Publish the  Application`, {});
          return { success: false, error: 'Failed to Publish the  Application' };
        }
      } catch (error) {
        this.setState({ isPublising: false });
        if (error.message.toString().toLowerCase() === 'network error') {
          toast.error(`Failed: Try again after sometime`, {});
        } else {
          toast.error(`Failed: ${error.message}`, {});
          return { success: false, error: errorMessage };
        }
      }
    };

    if (envType === 'PREVIEW') {
      return await preconfirm();
    } else {
      const text = `You are going to publish the project in ${name}:(${voca.titleCase(
        envType,
      )}) environment. Are you sure?`;
      showWarning(text, preconfirm, 'Publish');
    }
  };

  showContentForOpen = () => {
    const { domainName, url, uuid } = this.props.project;
    let urlToOpen = '';
    if (!domainName || domainName === url) {
      urlToOpen = `${process.env.REACT_APP_ORGANIZATION}${uuid}/project-detail`;
    } else {
      urlToOpen = `https://${domainName}`;
    }
    return (
      <>
        <div className="col-md-12 col-sm-12 pb-2">
          Publish your app for the end users. So that they can see the updated changes.
        </div>
        <div className="col-md-12 col-sm-12">
          Custom Domain:{' '}
          {!domainName || domainName === url ? (
            <a href={urlToOpen} target="_blank">
              Please, Map your custom domain!
            </a>
          ) : (
            <a href={urlToOpen} target="_blank">
              {voca.truncate(domainName, 30)}
            </a>
          )}
        </div>
        <div className="col-md-12 col-sm-12">
          Drapcode Domain:{' '}
          <a href={`https://${url}`} target="_blank">
            {voca.truncate(url, 30)}
          </a>
        </div>
      </>
    );
  };

  getRedirectUrl = () => {
    let domainName = window.location.hostname;
    let redirectUrl = `https://${domainName}/`;
    if (process.env.REACT_APP_ENVIRONMENT === 'DEV') {
      redirectUrl = `http://${domainName}:9075/`;
    } else if (process.env.REACT_APP_ENVIRONMENT === 'STAGING') {
      domainName = domainName.replace('builder.webkonnect.digital', 'builderc.webkonnect.digital');
      redirectUrl = `https://${domainName}/`;
    } else {
      domainName = domainName.replace('builder.mydrapcode.com', 'builderc.mydrapcode.com');
      redirectUrl = `https://${domainName}/`;
    }
    return redirectUrl;
  };

  showPopoverContent = () => {
    const { project, projectId, versions, pageId, editor, version, actions } = this.props;
    if (!project) {
      return '';
    }
    const redirectUrl = this.getRedirectUrl();
    let token = cookie.load('token');
    const { pages } = editor;
    const currentPage = filterByKey(pages, 'uuid', pageId);
    const slug = currentPage ? currentPage.slug : '';

    return (
      <PublishProjectModal
        project={project}
        popoverOpen={this.state.popoverOpen}
        redirectUrl={redirectUrl}
        projectId={projectId}
        token={token}
        toggle={this.toggle}
        generateProjectURL={this.generateProjectURL}
        selVersion={this.state.selVersion}
        handleVersionChange={this.handleVersionChange}
        versions={versions}
        publishApp={this.publishApp}
        isPublising={this.state.isPublising}
        restartApp={this.restartApp}
        slug={slug}
        version={version}
        actions={actions}
      />
    );
  };

  showPreviewModalContent = () => {
    const { project, versions, pageId, editor, version, actions, projectId } = this.props;
    if (!project) {
      return '';
    }
    const { pages } = editor;
    const currentPage = filterByKey(pages, 'uuid', pageId);
    const slug = currentPage ? currentPage.slug : '';

    return (
      <PreviewProjectModal
        project={project}
        previewModalOpen={this.state.previewModalOpen}
        togglePreview={this.togglePreview}
        generateProjectURL={this.generateProjectURL}
        selVersion={this.state.selVersion}
        handleVersionChange={this.handleVersionChange}
        versions={versions}
        publishApp={this.publishApp}
        isPublising={this.state.isPublising}
        slug={slug}
        version={version}
        actions={actions}
        projectId={projectId}
      />
    );
  };

  render() {
    return (
      <>
        <div id="gjs" />
        <div id="publish-popover"></div>
        {this.showPopoverContent()}
        {this.showPreviewModalContent()}
      </>
    );
  }
}

export default GEditor;
